import * as L from "leaflet";
import React from "react";
import { renderToString } from "react-dom/server";
import SearchIcon from "@material-ui/icons/Search";
import { Input, FormGroup, Label, Form } from "reactstrap";

L.Control.RecommendedAreas = L.Control.extend({
  initialize: function (layers) {
    this.layers = layers;
  },
  onAdd: function (map) {
    const container = L.DomUtil.create(
      "div",
      "leaflet-search-coordinates-container"
    );
    L.DomEvent.disableClickPropagation(container);
    container.innerHTML = renderToString(
      <FormGroup style={{ margin: 0 }} id="form">
        <Input
          type="checkbox"
          name="check"
          id="checkrecommended"
          style={{ margin: 0, marginTop: 1.5 }}
        />
        <Label
          for="checkrecommended"
          style={{ margin: 0, paddingLeft: 16, userSelect: "none" }}
        >
          Show only recommended areas
        </Label>
      </FormGroup>
    );

    container
      .querySelector("#checkrecommended")
      .addEventListener("change", (e) => {
        const filter = e.target.checked === true ? "recc=1" : "INCLUDE";
        this.layers.forEach((layer) => {
          layer.setParams({
            CQL_FILTER: filter,
          });
        });
      });
    return container;
  },
});

export default L.control.recommendedAreas = function (layers) {
  return new L.Control.RecommendedAreas(layers);
};
